// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-item[data-v-b8c2b622]:first-child {\n  margin-left: 2.5rem;\n}\n.notes-move[data-v-b8c2b622] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 220px;\n  margin-right: 60px;\n  max-width: 90%;\n}\n.customCardConatinerNotes[data-v-b8c2b622] {\n  margin-bottom: 16px !important;\n  border-radius: 4px;\n  border: 1px solid #e6e6e6;\n}\n.text-bold[data-v-b8c2b622] {\n  font-weight: 800;\n}", ""]);
// Exports
module.exports = exports;
